import React, { FC, useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import SwitchSelector from 'react-switch-selector';

import HeaderBtn from '../../headerBtn/headerBtn';

import { ReactComponent as SettingIcon } from '../../../assets/icons/settings.svg';
import { ReactComponent as IncreaseIcon } from '../../../assets/icons/increase.svg';
import { ReactComponent as ReduceIcon } from '../../../assets/icons/reduce.svg';
import { ReactComponent as FiltersIcon } from '../../../assets/icons/filter.svg';
import { ReactComponent as ActiveFiltersIcon } from '../../../assets/icons/filter_active.svg';

import { AppDispatch } from "../../../redux/reducer/store";
import { actionsReportsChart } from '../../../redux/action/charts/actionCharts';
import { reducerChartsFilters, reducerChangeDataCharts } from '../../../redux/reducer/charts/reducer/reducerCharts';

import ChartLoader from '../../custom/chartLoader/chartLoader';

import { defaultFilter } from '../../../utils/chartsData';

import "../charts.scss";
import { IChartOptions, IFiltersCharts } from '../../../types/chartsInterface';

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels,
  PointElement,
  LineElement
);

const options = [
  { value: 0, label: 'Проверка' },
  { value: 1, label: 'Оценка' }
];

const ReportsChart: FC<IChartOptions> = ({ id, copyChart, isCopy, pageId }) => {

  const dispatch: any = useDispatch<AppDispatch>();
  const listRef = useRef<HTMLDivElement | null>(null);

  const { data } = useSelector(
    (state: any) => state.user.user
  );

  const {
    pending,
    desktopData,
    desktopInputValues,
  } = useSelector((state: any) => state.charts?.chartsList);

  const { filters } = useSelector((state: any) => state.userReports.userReports);

  const index = desktopData[pageId || 0]?.find((el: { id: number }) => el.id === id) || {};
  const reportsChartsFilters = desktopInputValues?.[Number(pageId) || 0]?.[id] || null;

  const [isListRightPosition, setIsListRightPosition] = useState<boolean>(false);
  const [isIncreasedSize, setIsIncreasedSize] = useState<boolean>(false);
  const [isOpenSetting, setIsOpenSetting] = useState<boolean>(false);
  const [isChangeData, setIsChangeData] = useState<boolean>();
  const [isloader, setIsloader] = useState<boolean>(true);
  const [isOn, setIsOn] = useState<number>(0);

  const initialSelectedIndex = options.findIndex(option => option.value === isOn);
  const cheked = index ? index?.dataReportsCharts?.cheked : 0;
  const noCheked = index ? index?.dataReportsCharts?.noCheked : 0;

  const getChangeData = (data: IFiltersCharts) => {
    const changes: IFiltersCharts = {};

    const defaultReportsFilter = {
      ...defaultFilter,
      status: 'RATE_STATUS',
    };

    for (const key in defaultReportsFilter) {
      if (defaultReportsFilter.hasOwnProperty(key) && key !== 'status') {
        // @ts-ignore
        if (JSON.stringify(defaultReportsFilter[key]) !== JSON.stringify(data[key])) {
          // @ts-ignore
          changes[key] = data[key];
        }
      }
    }

    for (const key in data) {
      if (data.hasOwnProperty(key) && !defaultReportsFilter.hasOwnProperty(key)) {
        // @ts-ignore
        changes[key] = data[key];
      }
    };
    setIsChangeData(Object.keys(changes).length > 0);
    dispatch(reducerChangeDataCharts({ hasChanged: Object.keys(changes).length > 0, changes }));
  };

  const handleClickSetting = () => {
    if (isOpenSetting) {
    } else {
      getChangeData(reportsChartsFilters);
    }
    setIsOpenSetting(!isOpenSetting);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (listRef.current && !listRef.current.contains(event.target as Node)) {
      setIsOpenSetting(false);
    }
  };

  const handleChangeSwitchSelector = (newValue: any) => {
    setIsOn(newValue);
    dispatch(reducerChartsFilters({
      pageId,
      id, data:
      {
        ...reportsChartsFilters,
        status: newValue ? 'RATE_STATUS' : 'REVIEW_STATUS'
      }
    }));
    dispatch(actionsReportsChart(id, pageId));
  };

  useEffect(() => {
    if (reportsChartsFilters) {
      getChangeData(reportsChartsFilters);
    }
    // eslint-disable-next-line
  }, [reportsChartsFilters])

  useEffect(() => {
    if (isOpenSetting) {
      const listEl = listRef.current;
      if (listEl) {
        const list = listEl.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        setIsListRightPosition(list.right + 168 > viewportWidth);
      }
    }
    // eslint-disable-next-line
  }, [isOpenSetting]);

  useEffect(() => {
    if (filters) {
      setIsloader(true);
      dispatch(actionsReportsChart(id, pageId)).then(()=>{
        setIsloader(false);
      });
    }
    setIsOn(!reportsChartsFilters || reportsChartsFilters?.status === 'RATE_STATUS' ? 1 : 0);
    // eslint-disable-next-line
  }, [filters, pageId]);

  useEffect(() => {
    if (pending[pageId || 0]) {
      setIsloader(pending[pageId || '0']?.includes(id));
    }
    // eslint-disable-next-line
  }, [pending]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className={`content-charts ${isIncreasedSize ? 'content-charts_active' : ''}`}>
      <div className='charts__header'>
        <p className='charts__title'>{`Отчёты проверен/не проверен ${isCopy ? '(дубль)' : ''}`}</p>
        {(data.isAdmin || data.settings.reviewStatus) && <div className='switchContainer switchContainer_precent' style={{ width: ' 195px' }}>
          <SwitchSelector
            options={options}
            onChange={handleChangeSwitchSelector}
            forcedSelectedIndex={initialSelectedIndex}
            fontColor={"#000"}
            name={`checkStatus_${id}`}
          />
        </div>}
        <div className='charts__btn'>
          <div>
            {!isIncreasedSize && <IncreaseIcon className='charts__icon' onClick={() => setIsIncreasedSize(true)} />}
            {isIncreasedSize && <ReduceIcon className='charts__icon' onClick={() => setIsIncreasedSize(false)} />}
          </div>
          <div className='charts__headerbtn'>
            <HeaderBtn
              content=" "
              purpose="filtersCharts"
              modalTitle="Настройка отображения данных"
              selectId={id}
              action={actionsReportsChart}
              inputValuesCharts={reportsChartsFilters}
            />
            {(!isChangeData || !reportsChartsFilters) &&
              <FiltersIcon
                className={`charts__icon charts__icon_filters`}
                onClick={handleClickSetting} />}
            {isChangeData && reportsChartsFilters &&
              <ActiveFiltersIcon
                className={`charts__icon charts__icon_filters`}
                onClick={handleClickSetting} />}
          </div>
          <div ref={listRef}>
            <SettingIcon className='charts__icon' onClick={handleClickSetting} />
            {isOpenSetting &&
              <ul className={`charts__setting ${isListRightPosition ? 'charts__setting_right' : ''}`}>
                <li onClick={() => {
                  handleClickSetting();
                  copyChart(id);
                }}>Дублировать</li>
                <li>
                  <HeaderBtn
                    content="Удалить"
                    purpose="removeCharts"
                    modalTitle="Удалить диаграмму?"
                    selectId={id} />
                </li>
                <li>
                  <HeaderBtn
                    content="Скриншот"
                    purpose="screenCharts"
                    modalTitle="Сделать скриншот"
                    dataCharts={{
                      data: index,
                      isOn,
                      name: `Отчёты проверен/не проверен ${isCopy ? '(дубль)' : ''}`,
                      type: '',
                      isIncreasedSize,
                    }} />
                </li>
                {/* <li onClick={handleClickSetting}>Выгрузить данные</li> */}
              </ul>}
          </div>
        </div>
      </div>
      {isloader ?
        <ChartLoader />
        : cheked === 0 && noCheked === 0
          ? <p className='charts__text'>Отчёты в выбранных вами фильтрах не найдены. Убедитесь, что вы указали верно данные в фильтрах, расширьте рассматриваемый период  или географический охват.
          </p>
          : <>
            <div className='indicator'>
              <div className='indicator__block indicator__block_first'>
                <p className='indicator__header'>Кол-во отчётов, шт</p>
                <p>{(cheked + noCheked).toLocaleString('ru-RU') || 0}</p>
              </div>

              <div className='indicator__block indicator__block_second'>
                <p className='indicator__header'>Проверено, шт</p>
                <p>{cheked?.toLocaleString('ru-RU') || 0}</p>
              </div>

              <div className='indicator__block indicator__block_third'>
                <p className='indicator__header'>Не проверено, шт</p>
                <p>{noCheked?.toLocaleString('ru-RU') || 0}</p>
              </div>
            </div>
          </>
      }
    </div>
  )
};

export default ReportsChart;